@if (showMapPlaceholder()) {
  <mobi-cookie-consent-overlay />
} @else {
  <div #mapWrapper class="map h-full block"></div>
}
